import { IceRangesColorCodesEnum } from 'dashboard/enums/visuals/ice-color-codes.enum';
import { VisualsDashboardRangesColorEnum } from 'dashboard/enums/visuals/visuals-dashboard-colors.enum';

export const IceToDashboardColorMapRanges: Record<IceRangesColorCodesEnum, VisualsDashboardRangesColorEnum> = {
    [IceRangesColorCodesEnum.RANGE_80_100]: VisualsDashboardRangesColorEnum.EMERALD,
    [IceRangesColorCodesEnum.RANGE_60_79]: VisualsDashboardRangesColorEnum.LIME,
    [IceRangesColorCodesEnum.RANGE_40_59]: VisualsDashboardRangesColorEnum.AMBER,
    [IceRangesColorCodesEnum.RANGE_20_39]: VisualsDashboardRangesColorEnum.ORANGE,
    [IceRangesColorCodesEnum.RANGE_0_19]: VisualsDashboardRangesColorEnum.RED,
};
